/*
export class Product {
  public imageFeaturedUrl?;

  constructor(
    public id: number = 1,
    public date: string = new Date().toISOString().split('T')[0],
    public name: string = '',
    public description: string = '',
    public price: number = 0,
    public priceNormal: number = 0,
    public reduction: number = 0,
    public imageURLs: string[] = [],
    public imageRefs: string[] = [],
    public categories: {} = {},
    public ratings: {} = {},
    public currentRating: number = 0,
    public sale: boolean = false
  ) {}
}
*/
import { Gallery } from './detailGalerie.model';

// src/app/models/product-detail.model.ts

export class ProductDetail {
  // Declare class properties
  fabricant: string;
  fabricantUrl: string;
  nomProduit: string;
  descriptionCourte: string;
  baseline: string;
  disponibilite: string;
  prix: string;
  descriptionLongue: string;
  notesOlfactives: string;
  ingredients: string;
  detailsPrix: string;
  galerie: Gallery | null; // Properly typed as Gallery | null

  constructor(
    fabricant: string = '',
    fabricantUrl: string = '',
    nomProduit: string = '',
    descriptionCourte: string = '',
    baseline: string = '',
    disponibilite: string = '',
    prix: string = '',
    descriptionLongue: string = '',
    notesOlfactives: string = '',
    ingredients: string = '',
    detailsPrix: string = '',
    galerie: Gallery | null = null // Default value is null
  ) {
    // Assign constructor parameters to class properties
    this.fabricant = fabricant;
    this.fabricantUrl = fabricantUrl;
    this.nomProduit = nomProduit;
    this.descriptionCourte = descriptionCourte;
    this.baseline = baseline;
    this.disponibilite = disponibilite;
    this.prix = prix;
    this.descriptionLongue = descriptionLongue;
    this.notesOlfactives = notesOlfactives;
    this.ingredients = ingredients;
    this.detailsPrix = detailsPrix;
    this.galerie = galerie;
  }
}
export class Product {
  public imageFeaturedUrl?: string;

  constructor(
    public id: number = 1,
    public date: string = new Date().toISOString(),
    public name: string = '',
    public description: string = '',
    public price: number = 0,
    public priceNormal: number = 0,
    public reduction: number = 0,
    public imageURLs: string[] = [],
    public imageRefs: string[] = [],
    public categories: {} = {},
    public familles: {} = {},
    public sousFamilles: {} = {},
    public ratings: {} = {},
    public currentRating: number = 0,
    public sale: boolean = false,
    public sku: string = '',
    public marque: string = '',
    public url: string = '',
    public detail: ProductDetail = null
  ) {}
}
